import {
  GETREFUNDDETAILSPARTNER_SUCCESS,
  GETREFUNDDETAILSPARTNER_FAILED,
  RESET_GETREFUNDDETAILSPARTNER,
  LOADING_GETREFUNDDETAILSPARTNER,
  NETWORK_ERROR_GETREFUNDDETAILSPARTNER,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GETREFUNDDETAILSPARTNER:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case GETREFUNDDETAILSPARTNER_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case GETREFUNDDETAILSPARTNER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_GETREFUNDDETAILSPARTNER:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_GETREFUNDDETAILSPARTNER:
      return (state = initialState);
    default:
      return state;
  }
};
